import {Injectable} from '@angular/core'
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http'
import {Observable} from 'rxjs'

const httpOptions = {
  headers: new HttpHeaders({'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*'})
}

let endpoint = 'http://localhost:3000/'

@Injectable()
export class PaymentService {
  constructor(private http: HttpClient) {}
  /* Uses http.get() to load data from a single API endpoint */

  async createCustomer(customer: any) {
    const params = {
      description: 'UserId ' + customer.userId,
      address: customer.fullAddress,
      targetType: customer.tokenId,
      name: customer.fullName,
      email: customer.email,
      userId: customer.userId
    }

    return await this.http
      .post(endpoint + 'createCustomer', JSON.stringify(params), httpOptions)
      .toPromise()
  }

  async createSuscription(plan: string, tokenId: string, userId: string) {
    const params = {
      plan,
      customerId: tokenId,
      userId
    }
    console.log(params)
    return await this.http.post(endpoint + 'subscriptions', {params}, httpOptions).toPromise()
  }

  planItems() {
    const plan = [
      {
        name: 'Monthy',
        items: [
          'News & Columns',
          'Market Data',
          'Trade Data',
          'Customized Dashboards',
          'Lithium Prices**',
          'SignumBOX Reports: Li-Stats'
        ],
        key: 'month',
        amount: 180,
        description: '$180 Per month billed monthly '
      },
      {
        name: 'Yearly',
        items: [
          'News & Columns',
          'Market Data',
          'Trade Data',
          'Customized Dashboards',
          'Lithium Prices**',
          'SignumBOX Reports:'
        ],
        key: 'year',
        amount: 1700,
        description: '$141.1 Per month billed annually or $1700 per year.'
      },
      {
        name: 'Yearly',
        items: [
          'News & Columns',
          'Market Data',
          'Trade Data',
          'Customized Dashboards',
          'Lithium Prices**',
          'SignumBOX Reports:'
        ],
        subitems: ['Lithium Monthly Outlook', 'Report: Li-stats', 'SignumBOX Analysis'],
        key: 'year',
        amount: '',
        description: ''
      }
    ]
    return plan
  }
}
